export default __webpack_public_path__ + "static/2-892120e4a4cb2130de2b57ac6fc2bf98.jpeg";